// تسميات تقرير الحضور المطبوع (ثنائية اللغة) — مستقلة عن i18n لأن الـHTML يُحقن في نافذة جديدة.
import { COMMON } from "../payroll/reportLabelsCommon";

export const AL = {
  ar: {
    ...COMMON.ar,
    titleMany: "تقرير الحضور الشهري",
    titleOne: "تقرير حضور الموظف",
    titleCustom: "تقرير الحضور - فترة مخصصة",
    allBranches: "جميع الفروع",
    periodTo: "إلى",
    period: "الفترة",
    days: "يوم",
    payDay: "يوم الصرف",
    generatedAt: "تاريخ إنشاء التقرير",
    cards: ["إجمالي الموظفين", "أيام العمل", "أيام الغياب", "مرات التأخير"],
    cols: ["الموظف", "أيام العمل", "الغياب", "التأخير", "الإجازات", "العطل (كلي/مدفوع)"],
    leaveTypes: { annual: "سنوية", sick: "مرضية", emergency: "طارئة", unpaid: "غير مدفوعة" },
    explainTitle: "شرح الحسابات",
    explain: [
      ["أيام العمل", "الأيام التي سجّل فيها الموظف حضوراً وانصرافاً مكتملين."],
      ["الغياب", "الأيام الرسمية التي لم يُسجّل فيها حضور، أو سُجّل حضور بلا انصراف (القاعدة الذهبية)."],
      ["التأخير", "عدد مرات التأخير الرسمي بعد انتهاء فترة السماحة."],
      ["العطل (كلي/مدفوع)", "الرقم الأول إجمالي العطل الأسبوعية في الفترة، والثاني ما احتُسب مدفوعاً."],
    ],
    warnTitle: "⚠️ ملاحظة هامة حول احتساب الحضور",
    weekendIs: "أيام العطلة الأسبوعية لهذا الفرع:",
    paidWhen: "من سجّل حضوراً ولم يسجّل انصرافاً يُحتسب غائباً لذلك اليوم، وتعويض دقائق التأخير إلزامي قبل الانصراف.",
    footer: "تم إنشاء هذا التقرير بواسطة نظام إدارة الحضور",
    weekdays: ["الاثنين", "الثلاثاء", "الأربعاء", "الخميس", "الجمعة", "السبت", "الأحد"],
    none: "—",
    sealedBadge: "مختوم — الشهر مدفوع ومؤكَّد",
    pageOf: "صفحة {i} من {n}",
    signTitle: "التوقيع والاعتماد",
    signRoles: ["أعدّه (الموارد البشرية)", "راجعه (المدير المباشر)", "اعتمده (المدير العام)"],
    signNameDate: "الاسم والتاريخ",
    signNote: "هذا التقرير صادر إلكترونياً من نظام HELCOO، والأرقام الواردة فيه مأخوذة من السجل الرسمي للحضور.",
  },
  en: {
    ...COMMON.en,
    titleMany: "Monthly Attendance Report",
    titleOne: "Employee Attendance Report",
    titleCustom: "Attendance Report - Custom Period",
    allBranches: "All branches",
    periodTo: "to",
    period: "Period",
    days: "days",
    payDay: "pay day",
    generatedAt: "Generated on",
    cards: ["Total employees", "Work days", "Absence days", "Late occurrences"],
    cols: ["Employee", "Work days", "Absence", "Late", "Leaves", "Weekends (all/paid)"],
    leaveTypes: { annual: "Annual", sick: "Sick", emergency: "Emergency", unpaid: "Unpaid" },
    explainTitle: "How the figures are calculated",
    explain: [
      ["Work days", "Days with a complete check-in and check-out."],
      ["Absence", "Official days with no check-in, or a check-in without a check-out (golden rule)."],
      ["Late", "Official late occurrences after the grace period ends."],
      ["Weekends (all/paid)", "First number is all weekly days off in the period, second is those actually paid."],
    ],
    warnTitle: "⚠️ Important note about attendance calculation",
    weekendIs: "Weekly days off for this branch:",
    paidWhen: "A check-in without a check-out counts as an absence for that day, and making up late minutes is mandatory before checking out.",
    footer: "Generated by the attendance management system",
    weekdays: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
    none: "—",
    sealedBadge: "Sealed — month paid and acknowledged",
    pageOf: "Page {i} of {n}",
    signTitle: "Signatures and approval",
    signRoles: ["Prepared by (HR)", "Reviewed by (Direct manager)", "Approved by (General Manager)"],
    signNameDate: "Name and date",
    signNote: "This report was issued electronically by HELCOO; its figures come from the official attendance record.",
  },
};
